import { render, staticRenderFns } from "./ReportSaleChannelAndProduct.vue?vue&type=template&id=4ed5707e&"
import script from "./ReportSaleChannelAndProduct.vue?vue&type=script&lang=js&"
export * from "./ReportSaleChannelAndProduct.vue?vue&type=script&lang=js&"
import style0 from "./ReportSaleChannelAndProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports